import { render } from "./CrudSeccionRefactor.vue?vue&type=template&id=578143b5"
import script from "./CrudSeccionRefactor.vue?vue&type=script&lang=js"
export * from "./CrudSeccionRefactor.vue?vue&type=script&lang=js"

import "./CrudSeccionRefactor.vue?vue&type=style&index=0&id=578143b5&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__